import { type FC } from 'react';
import classes from '../styles/index.module.css';
import { useStyleContextState } from '../../styleContext';

export const ToolNavigationLinkActiveDot: FC = () => {
	const { mainColor } = useStyleContextState();

	return (
		<span
			className={classes.toolNavigationLink__dot}
			style={{ backgroundColor: mainColor }}
			data-testid='tool-navigation-active-dot'
		/>
	);
};
